import React from "react";

export default function TravelSafelyHero() {
  return (
    <section className="w-full bg-[#F4F1FC] overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 sm:px-10 lg:px-12 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        {/* ---------- LEFT: TEXT CONTENT ---------- */}
        <div className="text-center lg:text-left order-2 lg:order-1">
          {/* Badge */}
           <div className="inline-flex items-center gap-2 bg-purple-100 text-purple-700 text-xs font-semibold px-3 py-2 rounded-full mb-5">
            <span className="flex items-center justify-center w-4 h-4 ">
             <img src="/img/shared/safety-badge.svg" alt="Safety Badge" className="w-4 h-4" />
            </span>
            Safety First
          </div>

          {/* Heading */}
          <h1 className="font-extrabold leading-tight tracking-tight text-4xl sm:text-6xl">
            <span className="block text-purple-700">Travel Safely</span>
            <span className="block text-gray-900">on SoloConnect</span>
          </h1>

          {/* Paragraph */}
          <p className="mt-6 text-gray-500 text-base sm:text-sm leading-relaxed max-w-md mx-auto lg:mx-0">
            Your safety is our priority. Follow these simple travel tips to
            enjoy a worry-free, secure, and memorable journey with
            SoloConnect.
          </p>
        </div>

        {/* ---------- RIGHT: ILLUSTRATION ---------- */}
        <div className="relative w-full h-[320px] sm:h-[400px] lg:h-[440px] flex items-center justify-center order-1 lg:order-2">
          {/* Soft clouds */}
          <div className="absolute top-10 left-4 w-16 h-8 bg-white/70 rounded-full blur-[1px]" />
          <div className="absolute top-16 left-14 w-10 h-6 bg-white/70 rounded-full blur-[1px]" />
          <div className="absolute top-4 right-16 w-14 h-7 bg-white/60 rounded-full blur-[1px]" />

          {/* Sparkles */}
          <Sparkle className="absolute top-8 right-10 w-4 h-4 text-purple-400" />
          <Sparkle className="absolute top-24 left-2 w-3 h-3 text-purple-300" />
          <Sparkle className="absolute bottom-24 right-4 w-3 h-3 text-purple-300" />

          {/* Airplane with dashed trail */}
         <img
            src="/img/safety-tips/airplane.svg"
            alt="Airplane"
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full object-contain"
          />
        </div>
      </div>
    </section>
  );
}

function Sparkle({ className }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor">
      <path d="M12 0 L14 10 L24 12 L14 14 L12 24 L10 14 L0 12 L10 10 Z" />
    </svg>
  );
}